<template>
  <chatflow-page>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="flows"
      :search="search"
      :sort-by="['updatedAt']"
      :sort-desc="[true]"
      :items-per-page="10"
      class="shadow-xl cf-card"
      elevation="2"
    >
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-2 px-2">
          <v-toolbar-title class="text-h6 font-weight-medium">Chatflows</v-toolbar-title>
          <v-spacer />
          <v-alert
            v-if="configMissing"
            dense
            text
            type="warning"
            class="mr-3 mb-0 py-1"
          >
            config.json: chatflowURL
          </v-alert>
          <v-text-field
            v-model="search"
            dense
            outlined
            prepend-inner-icon="mdi-magnify"
            label="Ara"
            hide-details
            class="cf-search mr-3"
          />
          <v-btn
            v-if="hasAuth('New Chatflow')"
            color="primary"
            depressed
            @click="createFlow"
          >
            <v-icon left small>add</v-icon>
            Yeni akış
          </v-btn>
        </v-toolbar>
        <v-divider />
      </template>
      <template v-slot:item.active="{ item }">
        <v-chip small :color="item.active ? 'success' : 'grey'" dark>
          {{ item.active ? "Yayında" : "Taslak" }}
        </v-chip>
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ formatDate(item.updatedAt) }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn
          v-if="hasAuth('Edit Chatflow')"
          icon
          small
          :to="`/chatflows/${item.id}`"
        >
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn
          v-if="hasAuth('Delete Chatflow')"
          icon
          small
          @click="deleteFlow(item.id)"
        >
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-snackbar v-model="snack" :color="snackColor" bottom :timeout="3500">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn text dark v-bind="attrs" @click="snack = false">Kapat</v-btn>
      </template>
    </v-snackbar>
  </chatflow-page>
</template>

<script>
import { mapActions } from "vuex";
import ChatflowApi from "../api";
import ChatflowAuthMixin from "../mixins/auth";
import chatflowConfig from "../config";
import ChatflowPage from "../components/ChatflowPage.vue";
import { DEFAULT_GRAPH } from "../constants/nodeTypes";
import { timeAwareFormat } from "../../time";

export default {
  components: { ChatflowPage },
  mixins: [ChatflowAuthMixin("Chatflows")],
  computed: {
    configMissing() {
      return !chatflowConfig.isConfigured();
    },
  },
  data: () => ({
    loading: false,
    flows: [],
    search: "",
    snack: false,
    snackText: "",
    snackColor: "success",
    headers: [
      { text: "Ad", value: "name" },
      { text: "Durum", value: "active" },
      { text: "Güncellendi", value: "updatedAt" },
      { text: "", value: "action", sortable: false, width: 100 },
    ],
  }),
  created() {
    this.load();
  },
  methods: {
    ...mapActions("chatflows", { refreshStore: "loadFlows" }),
    formatDate(d) {
      return d && timeAwareFormat(d);
    },
    async load() {
      this.loading = true;
      try {
        this.flows = await ChatflowApi.getFlows();
        await this.refreshStore();
      } catch (e) {
        this.notify(e.response?.data?.message || "Akışlar yüklenemedi", "error");
      }
      this.loading = false;
    },
    async createFlow() {
      try {
        const flow = await ChatflowApi.createFlow({
          name: `Chatflow ${this.flows.length + 1}`,
          graph: DEFAULT_GRAPH,
        });
        await this.load();
        this.$router.push(`/chatflows/${flow.id}`);
      } catch (e) {
        this.notify(e.response?.data?.message || "Oluşturulamadı", "error");
      }
    },
    async deleteFlow(id) {
      if (!confirm("Bu akış silinsin mi?")) return;
      try {
        await ChatflowApi.deleteFlow(id);
        await this.load();
        this.notify("Silindi");
      } catch (e) {
        this.notify(e.response?.data?.message || "Silinemedi", "error");
      }
    },
    notify(text, color = "success") {
      this.snackText = text;
      this.snackColor = color;
      this.snack = true;
    },
  },
};
</script>

<style scoped>
.cf-card {
  border-radius: 8px;
}

.cf-search {
  max-width: 260px;
}
</style>
